export interface GeneralConfigurationType {
  id: string;
  name: string;
  configuration: any;
  created_at: string;
  updated_at: string;
}

export interface GeneralConfigurationResponseType {
  data: GeneralConfigurationType[];
  count: number;
  next?: string | null;
  previous?: string | null;
}

export interface GeneralConfigurationParamsType {
  name?: string;
  page?: number;
  page_size?: number;
}

/**
 * Shape of the `default-settings` general-configuration payload.
 *
 * Previously declared only in super-admin's GlobalSettingsApi while
 * apps/main referenced it without importing it — a latent TS2304.
 */
export interface GlobalSettingsConfig {
  addMoreButton: boolean;
  fileUploadLimit: number;
  showSortButton: boolean;
  showConsolidateButton: boolean;
  showChatbot: boolean;
  showOriginalFileInExplorer: boolean;
  showSelectAllInExplorer: boolean;
}

export const defaultGeneralConfiguration: GlobalSettingsConfig = {
  addMoreButton: true,
  fileUploadLimit: 10,
  showSortButton: true,
  showConsolidateButton: true,
  showChatbot: true,
  showOriginalFileInExplorer: false,
  showSelectAllInExplorer: true,
};
